import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { IRib } from 'shop';
import { AppThunk } from 'store';

import { OrganizationApi } from '../api/organization.api';
import {
  fetchRib,
  fetchRibFailed,
  fetchRibSuccedded,
} from '../slices/organization.slice';

export const addOrganizationRibThunk = (
  organizationID: string,
  rib: IRib,
  onError?: (err?: AxiosError) => void,
): AppThunk => async (dispatch: Dispatch<any>) => {
  let response: AxiosResponse<IRib> | null = null;
  dispatch(fetchRib({ key: 'add' }));

  try {
    response = await OrganizationApi.addRIB(organizationID, rib);
  } catch (error) {
    dispatch(fetchRibFailed({ key: 'add', error: error }));
    onError(error);
  }
  if (response && response.data) {
    // - Dispatch succeeded, set person
    const { data } = response;
    dispatch(fetchRibSuccedded({ data: data, key: 'add' }));
    onError(undefined);
  }
};
